<template>
  <div class="home"  align=center style="margin: 20px;">
    <!--
     <h2 style="margin: -20px 0 10px 0px;">池火灾分析模型</h2>
  -    <el-container class="container-panel" style="border: 1px solid;">
     <hr width='100%' style='margin-top:1px;border:1px solid lightgray;' />
     -->
    <fieldset align='center'  style="text-align:center;width:760px;height:850px;">
      <legend style="border:0px;background-color:white;">
        <h2> 池火灾分析模型</h2>
      </legend>
      <el-container class="container-panel">

      <!--      <el-header style="text-align: center;border: 1px solid;">-->
      <el-header style="text-align: center;">
        <h4>A</h4>
        <div style="display:flex;justify-content: center;align-items: center" >
          <div>
            <el-row :gutter="1" type="flex" justify="center" align="middle">
              <el-col :span="6" pull="6">物质名称:&nbsp</el-col>
              <el-col :span="6" pull="9">
                <el-input  v-model="in24" type="text" class="inputWidth" style="margin-left: 25px"/>
              </el-col>
              <el-col :span="6" pull="1" style="transform: translate(0,-3px)">单元名称: &nbsp</el-col>
              <el-col :span="6" pull="3" style="transform: translate(0,-5px)">

                <el-select v-model="in25" placeholder="请选择" class="inputWidth">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-header>
     <br><br>
      <hr width='100%' style='border:1px solid lightgray;' />
      <!--      <el-main style="text-align: center;border: 1px solid;">-->
      <el-main style="text-align: center; padding:  30px 0 0 0px!important;">
        <div style="display:flex;justify-content: center;" class="inputStyle" width="50%">
          <div  style="transform: translate(-40px)">
            <h4>B:池火灾输入与计算区</h4>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">液池面积:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in1" type="text"/>
                </el-col>
                <el-col :span="8"  style="transform: translate(5px);">m²</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">液池当量半径:</el-col>
                <el-col :span="6">
                  <el-input  @focus="mydob2()" v-model="in2" type="text"/>
                </el-col>
                <el-col :span="8"  style="transform: translate(3px);">m</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">燃烧速度:</el-col>
                <el-col :span="6">
                  <el-input v-model="in3" type="text"/>
                </el-col>
                <el-col :span="9" style="transform: translate(23px);">kg/(s * m²)</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8" value="1.29">周围空气密度:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in4" type="text"/>
                </el-col>
                <el-col :span="10" style="transform: translate(27px);">kg/m3[1.16-1.29]</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8" value="9.8">重力加速度:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in5" type="text"/>
                </el-col>
                <el-col :span="10" style="transform: translate(13px);">m/s² [9.8]</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">火焰高度:</el-col>
                <el-col :span="6">
                  <el-input  @focus="mydo"   v-model="in6" type="text"/>
                </el-col>
                <el-col :span="8" style="transform: translate(3px);">m</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8" value="0.24">效率因子:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in7" type="text"/>
                </el-col>
                <el-col :span="10" style="transform: translate(12px);">0.13-0.35</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">物质燃烧热:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in8" type="text"/>
                </el-col>
                <el-col :span="10" style="transform: translate(-2px);">J/kg</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">热辐射通量:</el-col>
                <el-col :span="6">
                  <el-input  @focus="mydo"  v-model="in9" type="text"/>
                </el-col>
                <el-col :span="10" style="transform: translate(5px);">kW/m²</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">热传导系数:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in10" type="text" value="1"/>
                </el-col>
                <el-col :span="10" style="transform: translate(5px);">[可取1]</el-col>
              </el-row>
            </div>
          </div>
          <div style="transform: translate(30px);border:1px solid gray;width:380px;">
            <h4>C:燃烧速度计算区</h4>
            <div>
              <el-radio v-model="radio" label="1">沸点高于环境温度</el-radio>
              <el-radio v-model="radio" label="2">沸点低于于环境温度</el-radio>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">燃烧热 Hc:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in16" type="text"/>
                </el-col>
                <el-col :span="10" pull="2" style="transform: translate(4px);">J/kg</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">气化热 Hc:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in17" type="text"/>
                </el-col>
                <el-col :span="10" pull="2" style="transform: translate(4px);">J/kg</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">比热容 Cp</el-col>
                <el-col :span="6">
                  <el-input   v-model="in18" type="text"/>
                </el-col>
                <el-col :span="10" pull="1" style="transform: translate(4px);">J/(kg * k)</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">环境温度 To:</el-col>
                <el-col :span="6">
                  <el-input   v-model="in19" type="text"/>
                </el-col>
                <el-col :span="10" pull="3" style="transform: translate(10px);">K</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8">液体沸点 Tb:</el-col>
                <el-col :span="6">
                  <el-input   @blur="mydoc"  v-model="in20" type="text"/>
                </el-col>
                <el-col :span="10" pull="3" style="transform: translate(10px);">K</el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="1">
                <el-col :span="8" @focus="mydoc">燃烧速度 mf:</el-col>
                <el-col :span="6">
                  <el-input v-model="in21"  @focus="mydoc" type="text"/>
                </el-col>
                <el-col :span="10" pull="1" style="transform: translate(10px);">kg/(S *m²)</el-col>
              </el-row>
            </div>

            <h4>D:液池面积计算区(m)</h4>
            <div class="inputComput">
              <el-row :gutter="1">
                <el-col :span="4">矩形:</el-col>
                <el-col :span="4">
                  <el-input   v-model="in11" type="text"/>
                </el-col>
                <el-col :span="2">
                  X
                </el-col>
                <el-col :span="4">
                  <el-input  @blur="mydod1"  v-model="in12" type="text"/>
                </el-col>
                <el-col :span="4">
                  =
                </el-col>
                <el-col :span="4">
                  <el-input   v-model="in13" @focus="mydod1"  type="text"/>
                </el-col>
              </el-row>
            </div>
            <div>
              <div class="inputComput">
                <el-row :gutter="1">
                  <el-col :span="4">圆形: </el-col>
                  <el-col :span="4">3.14</el-col>
                  <el-col :span="2">X</el-col>
                  <el-col :span="4">
                    <el-input  @blur="mydod2"  v-model="in14" type="text"/>
                  </el-col>
                  <el-col :span="4">
                    ²   =
                  </el-col>
                  <el-col :span="4">
                    <el-input   v-model="in15" @focus="mydod2"  type="text"/>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <!--      <el-footer style="border: 1px solid;">-->
        <br/>
        <hr width='100%' style='margin-top:1px;border:1px solid lightgray;' />

      <el-footer style="margin: 0 auto">
        <h4>E 计算结果区</h4>
        <el-row :gutter="1" type="flex" justify="center">
          <el-col :span="10" pull="5" class="inputStyle" style="text-align: right">
            <div style="display: flex;justify-content: space-around">
              <span>热通量kw/m²</span>     <span>目标距离m</span>
            </div>
            <div class="divFlex" style="display:flex;justify-content: space-around">
              <span>1.</span> <el-input   v-model="in26" type="text" disabled value="37.5"/><el-input   v-model="in27" type="text"/>
            </div>
            <div class="divFlex">
              <span>2.</span> <el-input   v-model="in28" type="text" disabled value="25.0"/> <el-input   v-model="in29" type="text"/>
            </div>
            <div class="divFlex">
              <span>3.</span> <el-input   v-model="in30" type="text" disabled value="12.5"/> <el-input  v-model="in31"  type="text"/>
            </div>
          </el-col>
          <el-col :span="10" push="3" class="inputStyle">
            <div style="margin-top: 4px;display: flex;justify-content: space-around">
              <span>热通量kw/m²</span>     <span>目标距离m</span>
            </div>
            <div class="divFlex">
              <span>4.</span> <el-input  v-model="in32"  type="text" disabled value="4.0"/> <el-input  v-model="in33"  type="text" />
            </div>
            <div class="divFlex">
              <span>5.</span> <el-input  v-model="in34"  type="text" disabled value="1.6"/> <el-input  v-model="in35"  type="text"/>
            </div>
          </el-col>
          <el-col :span="4" push="6">
            <el-button @click="mydo">计算</el-button>
            <el-button @click="myclear">清除数据</el-button>
            <el-button disabled>存入知识库</el-button>
            <el-button type="button" onclick="window.location.href='http://8.134.115.218/dist/help/poorfire.html'"  target='_blank'>导出报告</el-button>
          </el-col>
        </el-row>
       </el-footer>


    </el-container>
    </fieldset>

  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
      radio: '1',
      in1: '',
      in2: '',
      in3: '',
      in4: '1.29',
      in5: '9.8',
      in6: '',
      in7: '0.24',
      in8: '',
      in9: '',
      in10: '1',
      in11: '',
      in12: '',
      in13: '',
      in14: '',
      in15: '',
      in16: '',
      in17: '',
      in18: '',
      in19: '',
      in20: '',
      in21: '',
      in22: '',
      in23: '',
      in24: '',
      in25: '',
      in26: '37.5',
      in27: '',
      in28: '25.0',
      in29: '',
      in30: '12.5',
      in31: '',
      in32: '4.0',
      in33: '',
      in34: '1.6',
      in35: ''
    }
  },
  methods: {
    mydo () {
      this.mydoc();
      // console.log('0000000', this.radio);
      var R = parseFloat(this.in2),
        Dm = parseFloat(this.in3),
        P = parseFloat(this.in4),
        G = parseFloat(this.in5),
        H = 84 * R * Math.pow(Dm / P / Math.pow(2 * G * R, 0.5), 0.6);

       // console.log(H);
       if (H) {
           this.in6 = Math.round(H * 100) / 100;
        }
        var  F=parseFloat(this.in7),
             Fhc=parseFloat(this.in8),
             Q1=(3.1415926*R*R+2*3.1415926*R*H)*Dm*F*Fhc/(72*Math.pow(Dm,0.60)+1),
             Q= Q1/1000;
          if(Q)
          {
            this.in9=Math.round(Q*100)/100;
          }

         var  Tc =parseFloat(this.in10);
         var  TQ1=parseFloat(this.in26);
         var  TQ2=parseFloat(this.in28);
         var  TQ3=parseFloat(this.in30);
         var  TQ4=parseFloat(this.in32);
         var  TQ5=parseFloat(this.in34);

         var X1=Math.round(Math.pow(Q*Tc/TQ1/4/Math.PI,0.5)*10)/10;
         var X2=Math.round(Math.pow(Q*Tc/TQ2/4/Math.PI,0.5)*10)/10;
         var X3=Math.round(Math.pow(Q*Tc/TQ3/4/Math.PI,0.5)*10)/10;
         var X4=Math.round(Math.pow(Q*Tc/TQ4/4/Math.PI,0.5)*10)/10;
         var X5=Math.round(Math.pow(Q*Tc/TQ5/4/Math.PI,0.5)*10)/10;
        if(X1 || X5)
        {
         this.in27=X1;
         this.in29=X2;
         this.in31=X3;
         this.in33=X4;
         this.in35=X5;
        }
 /*
*/
    },
    mydoc () {

      //console.log('0000000', this.in16);

      if (this.radio=='1')
      {
         var Fhc = parseFloat(this.in16),
             Fh  = parseFloat(this.in17),
             Fcp = parseFloat(this.in18),
             Fto = parseFloat(this.in19),
             Ftb = parseFloat(this.in20),
             Dm = Fhc / (Fcp * Ftb - Fcp * Fto + Fh) / 1000;
        if(Dm) {
          this.in21 = Dm;
          this.in3 = Dm;
        }

      } else
      {
         var Fhc =parseFloat(this.in16),
             Fh = parseFloat(this.in17),
             Dm = Fhc / Fh / 1000;
         if(Dm) {
           this.in21 = Dm;
           this.in3 = Dm;
         }
      }
    },
    mydod1() {

      var L = parseFloat(this.in11),
          H = parseFloat(this.in12);
      var out=L * H;
      if(out){
        this.in13 = out;
        this.in1 = out;
      }
    },
    mydod2 () {
      var R = parseFloat(this.in14);
      if (R) {
        this.in15 = Math.round(R * R * 3.14159 * 10) / 10;
        this.in1 = Math.round(R * R * 3.14159 * 10) / 10;
       }
    },
    mydob2() {
          var  S= parseFloat(this.in1),
               R=Math.pow(S/3.14159,0.5);
          if(R)
            this.in2=Math.round(R*100)/100;

    },

    myclear(){
      this.in1='';
      this.in2= '';
      this.in3= '';
      this.in4= '1.29';
      this.in5= '9.8';
      this.in6= '';
      this.in7= '0.24';
      this.in8= '';
      this.in9= '',
      this.in10= '1';
      this.in11= '';
      this.in12= '';
      this.in13= '';
      this.in14= '';
      this.in15= '';
      this.in16= '';
      this.in17= '';
      this.in18= '';
      this.in19= '';
      this.in20= '';
      this.in21= '';
      this.in22= '';
      this.in23= '';
      this.in24= '';
      this.in25= '';
      this.in26='37.5';
      this.in27= '',
      this.in28= '25.0';
      this.in29= '';
      this.in30='12.5';
      this.in31= '';
      this.in32= '4.0';
      this.in33= '';
      this.in34='1.6';
      this.in35='' ;
    }

  }
}
</script>
<style scoped lang="scss">

.inputWidth{
  /deep/ .el-input__inner {
    width: 220px!important;
    height: 30px!important;
  }
  /deep/ .el-input {
    width: 220px!important;
    height: 30px!important;

  }
}

.el-select{
  width: 105px;
  height: 21px;
  /deep/.el-input__inner {
    height: 30px;
  }
  /deep/ .el-input__icon{
    line-height: 30px;
  }
}
.home {
  font-size: 12px;
}
.el-button {
  font-size: 12px;
}
//input {
//  width: 100px;
//}
.el-input {
  /deep/ .el-input__inner{
    width: 100px;
    height: 25px;
  }
}

span {
  font-size: 12px;
}
.inputStyle {
  div {
    margin: 2px 0;
  }
  .el-row {
    display: flex;
    align-items: center;
    .el-col:first-child {
      text-align: right;
      transform: translate(-3px);
    }
  }
  .divFlex {
    display: flex;
    align-items: center;
    text-align: center;
    /deep/ .el-input__inner {
      width: 80px!important;
    }
  }
}
.inputComput {
  /deep/ .el-input__inner {
    width: 70px!important;
  }
}
.firstCol {
}

.el-footer {
  input {
    //width: 60px;
    margin: 5px 10px;
  }
  .el-col {
    .el-button {
      display: block;
      width: 100px;
      height: 27px;
      font-size: 12px;
      text-align: center;
      margin: 3px;
      line-height: 0px;
    }
  }
}
h4 {
  font-size: 14px!important;
}
</style>
